export class SqlEngineAwsRuntimeConfig {
    'iamRoleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "iamRoleArn",
            "baseName": "iamRoleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlEngineAwsRuntimeConfig.attributeTypeMap;
    }
    constructor() {
    }
}
